import React from 'react';
import './MessageList.css';

const MessageList = ({ filters, onMessageSelect }) => {
  const dummyMessages = [
    { id: 1, subject: 'Sample Message 1', status: 'UNREAD' },
    { id: 2, subject: 'Sample Message 2', status: 'READ' },
  ];

  return (
    <div className="message-list">
      {dummyMessages.map(message => (
        <div 
          key={message.id} 
          className="message-item"
          onClick={() => onMessageSelect(message)}
        >
          <h3>{message.subject}</h3>
          <span className="message-status">{message.status}</span>
        </div>
      ))}
    </div>
  );
};

export default MessageList; 